module.exports = __webpack_public_path__ + "media/images/icon__arrow-right--rb-gray@2x-e24e0b1c595ee7855fb1c8a014d68ad9.png";